var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { useWixSdk } from './useSDK';
export var withWixSdk = function (Component) {
    var Wrapped = function (props) {
        var wixSDK = useWixSdk();
        return React.createElement(Component, __assign({}, __assign(__assign({}, props), { wixSDK: wixSDK })));
    };
    return Wrapped;
};
//# sourceMappingURL=withWixSDK.js.map